export const DURATION_ANIMATION = 250;
